'use client'

import { gameIsOnlyAdmin } from '@patrianna/shared-utils'
import { notFound } from 'next/navigation'

import { LoaderFullscreen } from 'components/Loader'
import { useAppSelector } from 'store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { getIsAdminUserSelector } from 'store/modules/user/selectors'

import type { ReactNode } from 'react'

type GameIsAdminOnlyProps = {
  gameLaunchDate: string
  children: ReactNode
  showLoader?: boolean
}

export function GameIsAdminOnly(props: GameIsAdminOnlyProps) {
  const { gameLaunchDate, children, showLoader = true } = props
  const isAdmin = useAppSelector(getIsAdminUserSelector)
  const isAppInitialized = useAppSelector(isAppInitializedSelector)
  const isGameAdminOnly = gameIsOnlyAdmin(isAdmin, gameLaunchDate)

  if (isAppInitialized && isGameAdminOnly) {
    notFound()
  }

  // If there's no launch date, or the launch date is already in the past,
  // the game is definitively public — render immediately without waiting
  // for app initialization. This avoids blocking LCP on already-launched games.
  const isMaybeAdminOnly = Boolean(gameLaunchDate) && Date.now() < Date.parse(gameLaunchDate)

  if (!isAppInitialized && isMaybeAdminOnly) {
    return showLoader ? <LoaderFullscreen /> : null
  }

  return children
}
